import { render, staticRenderFns } from "./ResourcesIndexCreate.vue?vue&type=template&id=a818b45e"
import script from "./ResourcesIndexCreate.vue?vue&type=script&lang=js"
export * from "./ResourcesIndexCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports